import { useTranslation } from "react-i18next";

import { ILead } from "../../../models/Lead";
import ClickToEdit from "../../shared/ClickToEdit";
import LeadPaymentDetails from "../LeadInformation/LeadPaymentDetails";

export default function LeadPaymentDetailsTab({ lead }: { lead: ILead }) {
  const { t } = useTranslation("leads");
  return (
    <div className="[&>*]:shadow-none [&>*]:border-0 [&>*]:rounded-none">
      <ClickToEdit name={t("Payment Details")}>
        <LeadPaymentDetails lead={lead} />
      </ClickToEdit>
    </div>
  );
}
